module.exports = __webpack_public_path__ + "static/media/kg.094c4395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kg.svg
// module id = 161
// module chunks = 0